import { PaginationHelper } from '@/helpers/paginationHelper'
import { BaseResponseDto } from '@/models/dtos/baseReponseDto'
import { GroupedWorkbookEntryDto } from '@/models/dtos/groupedWorkbookEntryDto'
import { PagedResponseDto } from '@/models/dtos/pagedResponseDto'
import { WorkbookEntryDto } from '@/models/dtos/workbookEntryDto'
import { WorkbookEntryFiltersDto } from '@/models/dtos/workbookEntryFiltersDto'
import { WorkbookEntryPaginationDto } from '@/models/dtos/workbookEntryPaginationDto'
import axios from 'axios'
import { Endpoints } from './_endpoints'

export abstract class WorkbookService {
  static async getAll(currentPage?: number, pageSize?: number): Promise<PagedResponseDto<WorkbookEntryDto>> {
    const pagination = PaginationHelper.getModel(currentPage, pageSize)
    const result = await axios
      .get<BaseResponseDto<PagedResponseDto<WorkbookEntryDto>>>(Endpoints.workbook.getAll,
        {
          params: {
            ...pagination
          }
        })

    if (!result.data.dto) throw new Error('Cannot get data')

    return result.data.dto
  }

  static async getUserEntries(userId: string, currentPage?: number, pageSize?: number): Promise<PagedResponseDto<WorkbookEntryDto>> {
    const pagination = PaginationHelper.getModel(currentPage, pageSize)
    const result = await axios
      .get<BaseResponseDto<PagedResponseDto<WorkbookEntryDto>>>(Endpoints.workbook.getUserEntries,
        {
          params: {
            userId: userId,
            ...pagination
          }
        })

    if (!result.data.dto) throw new Error('Cannot get data')

    return result.data.dto
  }

  static async getProjectEntries(projectId: string, currentPage?: number, pageSize?: number, filters?: WorkbookEntryFiltersDto): Promise<PagedResponseDto<WorkbookEntryDto>> {
    const pagination = PaginationHelper.getModel(currentPage, pageSize)
    const paginationModel: WorkbookEntryPaginationDto = { pagination, filters }

    const result = await axios
      .post<BaseResponseDto<PagedResponseDto<WorkbookEntryDto>>>(Endpoints.workbook.getProjectEntries, paginationModel, {
        params: {
          projectId
        }
      })

    if (!result.data.dto) throw new Error('Cannot get data')

    return result.data.dto
  }

  static async addWorkbookEntry(groupedWorkbookEntry: GroupedWorkbookEntryDto): Promise<BaseResponseDto<any>> {
    const result = await axios
      .post<BaseResponseDto<any>>(Endpoints.workbook.addWorkbookEntry, groupedWorkbookEntry)

    return result.data
  }

  static async updateWorkbookEntry(workbookEntry: WorkbookEntryDto): Promise<BaseResponseDto<any>> {
    const result = await axios
      .put<BaseResponseDto<any>>(Endpoints.workbook.editWorkbookEntry, workbookEntry)

    return result.data
  }

  static async removeWorkbookEntry(workbookEntryId: string): Promise<void> {
    await axios
      .delete<BaseResponseDto<any>>(Endpoints.workbook.removeWorkbookEntry, {
        params: {
          id: workbookEntryId
        }
      })
  }

  static async getWorkbookFromRange(start: Date, end?: Date): Promise<WorkbookEntryDto[]> {
    const result = await axios
      .get<BaseResponseDto<WorkbookEntryDto[]>>(Endpoints.workbook.getUserEntriesFromRange, {
        params: {
          start: start,
          end: end
        }
      })

    return result.data?.dto || []
  }
}
